module.exports = __webpack_public_path__ + "img/i_main_n_msg.281a2e84.svg";